
(function ($, Drupal, drupalSettings) {
	'use strict';

	var initialized = false;

	// define some vars
	const g_mobileNavLimit = 992;
	let	g_isMobileDisplay = false,
		g_isMobile = false,
		g_isTouch = false,
		g_isTouchDeviceOnDesktopNav = false,
		g_wasInitialized = false,
		g_$footerCopy = null;

	Drupal.behaviors.apaptativeEcoparc = {
		attach: function(context, setting){
			if (!initialized) {
				initialized = true;
				Drupal.behaviors.apaptativeEcoparc.init();
			}
		},
		init:function(){
			var ref = this;
			const parser = new UAParser();
			const isTouchDevice = 'ontouchstart' in document.documentElement;
			g_isMobile = parser.getDevice().type === "mobile" || ((parser.getDevice().type === "tablet") && $(window).width() <= g_mobileNavLimit);
			// mode menu desktop sur touch device
			if ((parser.getDevice().type === "tablet" || isTouchDevice) && $(window).width() > g_mobileNavLimit) {
				g_isTouchDeviceOnDesktopNav = true;
			}
			if (g_isMobile || g_isTouchDeviceOnDesktopNav) g_isTouch = true;
			if (g_$footerCopy === null) {
				g_$footerCopy = $('footer .container').clone();
			}
			ref.setDisplayType();
			$(window).on('resize', function(e) {
				ref.setDisplayType();
			});

		},

		setMobile:function() {
			g_isMobileDisplay = true;
			g_$footerCopy.appendTo($('#main-nav-wrapper'));
		},

		setDesktop:function() {
			g_isMobileDisplay = false;
			g_$footerCopy.remove();
		},

		setDisplayType:function() {
			// manage ios safari bottom bar (open or not from scroll)
			document.body.height = window.innerHeight;
			const winW = $(window).width();
			if (winW <= g_mobileNavLimit && !g_isMobileDisplay) {
				this.setMobile();
			} else if (winW > g_mobileNavLimit && g_isMobileDisplay) {
				this.setDesktop();
			}
			g_wasInitialized = true;
		},

	};
})(jQuery, Drupal, drupalSettings);


